import {Route, Navigate} from "react-router-dom";
import {SentryRoutes} from "../../utils/sentryRoute";

import {AdminLayout} from "../../atoms/admin-layout";
import {DocumentTitle} from "../../atoms/document-title";
import {FeatureFlagsHeader} from "./atoms/";
import {PageAdmin404} from "../page-admin-404";
import {PageAdminFeatureFlagsByFacilities} from "./PageAdminFeatureFlagsByFacilities";
import {PageAdminFeatureFlagsByOrganizations} from "./PageAdminFeatureFlagsByOrganizations";

export const FeatureFlagsRouter = () => (
  <>
    <DocumentTitle title={"Reside - Admin - Feature Flags"} />
    <AdminLayout>
      <FeatureFlagsHeader />
      <SentryRoutes>
        <Route
          index
          element={
            <Navigate to="/admin/feature-flags/organizations" replace />
          }
        />
        <Route
          path="organizations"
          element={<PageAdminFeatureFlagsByOrganizations />}
        />
        <Route
          path="facilities"
          element={<PageAdminFeatureFlagsByFacilities />}
        />
        <Route path="*" element={<PageAdmin404 />} />
      </SentryRoutes>
    </AdminLayout>
  </>
);
